<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'allReceivedSendOuts',
        }"
      >
        <router-link
          :to="{
            name: 'allReceivedSendOuts',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveReceivedSendOuts',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>

      <li>
        <router-link
          :to="{
            name: 'CompleteReceivedSendOuts',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
